import { render, staticRenderFns } from "./ReferralPromotionCreateForm.vue?vue&type=template&id=22accd06&"
import script from "./ReferralPromotionCreateForm.vue?vue&type=script&lang=js&"
export * from "./ReferralPromotionCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22accd06')) {
      api.createRecord('22accd06', component.options)
    } else {
      api.reload('22accd06', component.options)
    }
    module.hot.accept("./ReferralPromotionCreateForm.vue?vue&type=template&id=22accd06&", function () {
      api.rerender('22accd06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ReferralPromotionCreateForm.vue"
export default component.exports